import { OnboardingActionTypes } from './types';
import { action } from 'typesafe-actions';

export const saveUserProfileStart = (payload: any) =>
  action(OnboardingActionTypes.SAVE_USER_PROFILE_START, payload);
export const saveUserProfileSuccess = (payload: any) =>
  action(OnboardingActionTypes.SAVE_USER_PROFILE_SUCCESS, payload);
export const saveUserProfileFailure = (error: string) =>
  action(OnboardingActionTypes.SAVE_USER_PROFILE_FAILURE, error);

export const requestUserLinkingStart = (payload: any) =>
  action(OnboardingActionTypes.REQUEST_USER_LINKING_START, payload);
export const requestUserLinkingSuccess = (payload: any) =>
  action(OnboardingActionTypes.REQUEST_USER_LINKING_SUCCESS, payload);
export const requestUserLinkingFailure = (error: string) =>
  action(OnboardingActionTypes.REQUEST_USER_LINKING_FAILURE, error);

export const verifyUserLinkingStart = (payload: any) =>
  action(OnboardingActionTypes.VERIFY_USER_LINKING_START, payload);
export const verifyUserLinkingSuccess = (payload: any) =>
  action(OnboardingActionTypes.VERIFY_USER_LINKING_SUCCESS, payload);
export const verifyUserLinkingFailure = (error: string) =>
  action(OnboardingActionTypes.VERIFY_USER_LINKING_FAILURE, error);

export const confirmUserLinkingStart = (payload: any) =>
  action(OnboardingActionTypes.CONFIRM_USER_LINKING_START, payload);
export const confirmUserLinkingSuccess = (payload: any) =>
  action(OnboardingActionTypes.CONFIRM_USER_LINKING_SUCCESS, payload);
export const confirmUserLinkingFailure = (error: string) =>
  action(OnboardingActionTypes.CONFIRM_USER_LINKING_FAILURE, error);

export const setEmailLinkingStart = (payload: any) =>
  action(OnboardingActionTypes.SET_EMAIL_LINKING_START, payload);
export const setEmailLinkingSuccess = (payload: any) =>
  action(OnboardingActionTypes.SET_EMAIL_LINKING_SUCCESS, payload);
export const setEmailLinkingFailure = (error: string) =>
  action(OnboardingActionTypes.SET_EMAIL_LINKING_FAILURE, error);

export const importEnquiriesStart = (payload: any) =>
  action(OnboardingActionTypes.IMPORT_ENQUIRIES_START, payload);
export const importEnquiriesSuccess = (payload: any) =>
  action(OnboardingActionTypes.IMPORT_ENQUIRIES_SUCCESS, payload);
export const importEnquiriesFailure = (error: string) =>
  action(OnboardingActionTypes.IMPORT_ENQUIRIES_FAILURE, error);

export const fetchImportEnquiriesStatusStart = (payload: any) =>
  action(OnboardingActionTypes.FETCH_IMPORT_ENQUIRIES_STATUS_START, payload);
export const fetchImportEnquiriesStatusSuccess = (payload: any) =>
  action(OnboardingActionTypes.FETCH_IMPORT_ENQUIRIES_STATUS_SUCCESS, payload);
export const fetchImportEnquiriesStatusFailure = (error: string) =>
  action(OnboardingActionTypes.FETCH_IMPORT_ENQUIRIES_STATUS_FAILURE, error);
